import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import routeConfigs from '@src/pages/app-router/route-configs';
import { computed, observable } from 'mobx';
import ZtServiceFactory from '@src/services/json';

import reload from '@src/utils/reload';
import { noop } from '@src/utils/common-util';
import BusinessAccountInfoStore from '@src/business-components/business-account-info';
import { isWxMiniProgram } from 'detect-mobile-device';

class BaseStore {
  /**
   * 历史记录
   */
  @observable $history;

  /**
   * store中初始化service接口变量
   */
  $ztService = ZtServiceFactory.getDefaultInstance();

  /**
   * 获取登录账号信息
   * @type {BusinessAccountInfoStore}
   */
  businessAccountInfo = new BusinessAccountInfoStore();

  /**
   * 登录状态
   * @returns {*}
   */
  @computed
  get loginState() {
    // 判断是否存在用户账号名来确认是否存在
    return this.businessAccountInfo.username;
  }

  /**
   * wegame/金山通行证登录状态,应用场景,通过QQ和微信进行第三方授权后,领奖时需要支持wegame和金山通行证登录绑定时使用.
   * 注意:wegame登录的信息是由第三方登录信息接口返回的,但是login_type标记是"passport"
   * @returns {*}
   */
  @computed
  get passportLoginState() {
    return !!this.businessAccountInfo.xoyoAuthUsername;
  }

  /**
   * 跳转至具体的路由
   * @param type
   */
  redirect(type) {
    this.$history.push(routeConfigs[type].path);
  }

  use(props) {
    this.$props = props;
    this.$history = useHistory();
    /**
     * 路由参数
     * @type {History<LocationState>}
     */
    this.$routeParams = useParams();
    this.$routeMatch = useRouteMatch();
    /**
     * 登录
     */
    this.login = ({ isWegameLoginRequired = false, wegameLogin = noop } = {}) => {
      if (isWegameLoginRequired && isWxMiniProgram()) {
        /**
         * 如果是在小程序内需要支持wegame登录,此时需自定义在小程序内点击WeGame登录按钮时执行的业务方法
         */
        window.XPASS.wegameCustomLoginFunction = wegameLogin;
      }

      window.XPASS.signin({
        onLoginSuccess: res => {
          reload();
        }
      });
    };

    /**
     * 判断是否登录
     */
    this.isLogin = (onSuccess = noop, onFail = noop) => {
      if (this.loginState) {
        onSuccess();
      } else {
        onFail ? onFail() : this.login();
      }
    };
  }
}

export default BaseStore;
